export const PERMISSION_LABEL_VI = {
  BANK_ACCOUNT: "Tài khoản ngân hàng",
  DEBT: "Công nợ",
  EXPORT_JOB: "Quản lý xuất file",
  INVENTORY: "Tồn kho",
  MEASUREMENT_UNIT: "Đơn vị tính",
  PARTNER: "Đối tác",
  PAYMENT_JOURNAL: "Sổ cái thanh toán",
  PERMISSION: "Phân quyền",
  PRODUCT: "Sản phẩm",
  PRODUCT_CATEGORY: "Nhóm mặt hàng",
  PURCHASE_ORDER: "Đơn mua hàng",
  REGION: "Địa bàn",
  REPORT: "Báo cáo",
  SALE_ORDER: "Đơn bán hàng",
  USER: "Người dùng",
  WAREHOUSE: "Kho hàng",
};
